<template>
    <div>
        <div class="box1">
            <div class="box1_left">
                <div class="text1">一站式家政系统解决方案</div>
                <div class="text2">您的全场景家政系统伙伴</div>
                <el-button type="primary" @click="login" style="font-size: 22px;">免费试用</el-button>
            </div>
            <div class="box1_right">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fef37e861d.png" style="width: 150px;" alt="">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fef4c3e230.png" style="width: 150px;" alt="">
            </div>
        </div>
        <div class="box2">
           <div style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 20px;">服务支持</div>
                <div class="font_size_31">定制化设计界面，精装更具质感；专属运营助力，全程一对一在线服务</div>
            </div>
            <div class="flexBox">
                <div class="flexBox_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fe9499db06.png" style="width: 100px" alt="">
                    <div class="flexBox_item_text">技术保障</div>
                </div>
                <div class="flexBox_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fe9639586d.png" style="width: 100px" alt="">
                    <div class="flexBox_item_text">视觉优化支持</div>
                </div>
                <div class="flexBox_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fe97f56980.png" style="width: 100px" alt="">
                    <div class="flexBox_item_text">爆款内容运营</div>
                </div>
                <div class="flexBox_item">
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fe98b9a190.png" style="width: 100px" alt="">
                    <div class="flexBox_item_text">行业深度顾问</div>
                </div>
            </div>
        </div>
        <div class="box3">
            <div class="font_size_26" style="margin-bottom: 20px;">体验更安心的家政小程序</div>
            <div class="box3_flex">
                <div style="display: flex;flex-direction: column;gap: 130px;">
                    <div class="iconBox">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692ff39905fea.png" style="width: 50px;" alt=""></img>
                        <div>高效获客 / 用户留存</div>
                    </div>
                    <div class="iconBox">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692ff3b40a1ec.png" style="width: 50px;" alt=""></img>
                        <div>营销多元 / 体系健全</div>
                    </div>
                </div>
                <div>
                    <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fef37e861d.png" style="width: 210px;" alt="">
                </div>
                <div style="display: flex;flex-direction: column;gap: 130px;">
                    <div class="iconBox">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692ff3c7ed643.png" style="width: 50px;" alt=""></img>
                        <div>节约成本 / 推广便捷</div>
                    </div>
                    <div class="iconBox">
                        <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692ff3d724eac.png" style="width: 50px;" alt=""></img>
                        <div>数据保障 / 售后优质</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box4">
            <div style="position: relative;">
                <div class="font_size_26" style="margin-bottom: 20px;">专业家政服务形象</div>
                <div class="font_size_31">提供全类目家政服务，多模块灵活组合，打造更专业形象</div>
            </div>
            <div class="box4_item">
                <div class="box4_item_left">
                    <div><span>免费提供</span>首次家政装修服务</div>
                    <div>新系统自带专属服务形象，可调整色调，展现更专业家政形象（付费可选）</div>
                    <div>数百篇文案<span>免费试用</span>，助力家政企业发展</div>
                    <div><span>免费提供</span>手机宣传海报模板，支持家政宣传活动</div>
                </div>
                <div class="box1_right">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fef37e861d.png" style="width: 150px;" alt="">
                <img src="https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fef4c3e230.png" style="width: 150px;" alt="">
            </div>
            </div>
        </div>
        <div class="box5">
            <div class="text3">集成多重商业模式，助您轻松运营获利</div>
            <div class="text4">免费注册，开启智能管理</div>
            <div class="text5" @click="goInfo">立即咨询</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Product',
    data(){
        return {}
    },
    methods: {
        goInfo(){
            this.$router.push({name: "Infos"});
        },
        login(){
            window.open('https://llhsh.zhelihao123.com/admin/')
        },
    }
}
</script>

<style scoped>
.box1{background: #EDF4FF;padding: 80px 0 60px 0;box-sizing: border-box;display: flex;align-items: center;justify-content: center;gap: 100px;}
.box2{background: #fff;padding: 60px 0;}
.box3{background: #EDF4FF;padding:50px 0;box-sizing: border-box;}
.box4{margin: 50px 0;}
.box5{margin-top: 50px;background-image: url("https://llhsh.zhelihao123.com/manage/public/upload/admin/20251203/692fffa366ea7.png");background-repeat: no-repeat;background-size: 100% 100%;text-align: center;padding: 40px 0;}
.box1_left{ }
.text1{font-size: 3.84em;color: #333;}
.text2{font-size: 2.5em;color: #4c4c4c;margin: 5px 0 50px 0;}
.text3{font-size: 2.5em;color: #fff;}
.text4{font-size: 1.8em;color: #fff;margin: 5px 0 50px 0;}
.text5{display: inline-block;padding: 8px 35px;background: rgba(255,255,255,0.6);color: #1773FF;border: 1px solid #fff;border-radius: 10px;cursor: pointer;}
.box1_right{display: flex;gap: 40px;}
.font_size_26{font-size: 2.3em;color: #324148;margin: 10px 0;margin-bottom: 40px;font-weight: bold;text-align: center;}
.font_size_27{font-size: 1.5em;color: #333;margin: 10px 0;margin-bottom: 40px;}
.font_size_31{font-size: 1.4em;color: #4C4C4C;margin: 0px 0;margin-bottom: 20px;text-align: center;display: flex;justify-content: center;}
.flexBox{display: flex;align-items: center;justify-content: center;gap: 80px;margin-top: 50px;}
.flexBox_item{text-align: center;}
.flexBox_item_text{margin-top: 5px; font-size: 0.9em;color: #333;}
.box3_flex{display: flex;justify-content: center;margin-top: 40px;gap: 130px;align-items: center;}
.iconBox{text-align: center;color: #4c4c4C;}
.box4_item{border: 1px solid #979797;width: 90%;border-radius: 20px;padding: 50px 100px;box-sizing: border-box;margin-left: 5%;display: flex;align-items: center;justify-content: space-between;}
span{color: #ED3733;}
.box4_item_left{color: #4C4C4C;font-size: 1.4em;line-height: 60px;}
</style>
